import { render, staticRenderFns } from "./Agreement-1-3.vue?vue&type=template&id=9558b068&"
import script from "./Agreement-1-3.vue?vue&type=script&lang=js&"
export * from "./Agreement-1-3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports